module.exports = __webpack_public_path__ + "static/media/holidays.350937bf.svg";